import useHttpLoader from '../../../../../../hooks/useHttpLoader'
import { useRecoilState } from 'recoil'
import sandboxAtom from '../../../../../Sandbox/sandbox.atom'
import { useState } from 'react'
import { ILevel } from '../../../../../../types/tasks.types'
import levelsService from '../../../../../../services/levels.service'
import arrayUtils from '../../../../../../utils/array.utils'
import Modal from '../../../../../../shared/Modal'
import TextField from '../../../../../../shared/Forms/TextField'
import TextInput from '../../../../../../shared/Inputs/TextInput'
import NumberInput from '../../../../../../shared/Inputs/NumberInput'
import Textarea from '../../../../../../shared/Inputs/Textarea'
import Button from '../../../../../../shared/Buttons/Button'

interface IProps {
  onClose: () => void
  levelId: ILevel['id']
}

const EditLevelModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [sandboxState, setSandboxState] = useRecoilState(sandboxAtom)

  const level = sandboxState.levels.find((l) => l.id === props.levelId)
  const [draft, setDraft] = useState(level)

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(levelsService.update(draft.id, draft), (resp) => {
      if (resp.status === 'success') {
        setSandboxState((prev) => ({
          ...prev,
          levels: arrayUtils.updateItem({ items: prev.levels }, resp.body).items,
        }))
        props.onClose()
      }
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        <h2 style={{ marginBottom: '1em', fontSize: 28 }}>Создание уровня</h2>
        <TextField header="ID">
          <TextInput value={draft.id} name="id" onChange={handleChange} placeHolder="ID (For devs only)" />
        </TextField>
        <TextField header="Ordering index">
          <NumberInput value={draft.orderingIndex} onChange={handleChange} name="orderingIndex" />
        </TextField>
        <TextField header="Название">
          <TextInput value={draft.name} name="name" onChange={handleChange} placeHolder="Чтение по слогам" />
        </TextField>
        <TextField header="Описание">
          <Textarea
            value={draft.description}
            name="description"
            onChange={handleChange}
            placeHolder="Чтение по слогам"
          />
        </TextField>
      </div>
      <div className="form-footer">
        <Button onClick={handleSave} loading={loading}>
          Сохранить
        </Button>
        <Button onClick={props.onClose}>Отмена</Button>
      </div>
    </Modal>
  )
}

export default EditLevelModal
